<template>
  <body>
    <div class="h-full d-flex" id="wrapper">
      <!-- Page Content -->
      <div id="page-content-wrapper">
        <nav
          class="navbar navbar-expand-lg navbar-light border-bottom">
          <router-link to="/" class="menu-item menu-link-main custom-logo-link"
            id="imagen"
            rel="home"
            aria-current="page"
          >
            <img
              height="60"
              src="../assets/LogoH35-02.png"
              class="custom-logo"
              alt="Te lo traigo logo"
              style="position: relative; z-index: 3; scale: 1.05"
              sizes="(max-width: 410px) 100vw, 410px"
            />
          </router-link>

          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            @click="ocultarHeader"
          >
            <span class="navbar-toggler-icon"></span>
          </button>

          <div
            class="navbar-collapse collapse"
            id="navbarSupportedContent"
            style
          >
            <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
              <li class="nav-item active">
                <router-link v-show="!logueado" to="/login"
                  ><a class="nav-link text-white"
                    ><b-icon
                      icon="person-fill"
                      aria-hidden="true"
                    ></b-icon>
                    Iniciar sesión</a
                  ></router-link
                >
              </li>
              <li v-show="!logueado" class="nav-item">
                <router-link to="/registrarse"
                  ><a class="nav-link text-white"
                    ><b-icon
                      icon="person-plus-fill"
                      aria-hidden="true"
                    ></b-icon>
                    Registrarse</a
                  ></router-link
                >
              </li>
              <li class="nav-item" v-show="logueado">
                <router-link to="/"
                  ><a class="nav-link text-white"
                    ><b-icon icon="list-ul" aria-hidden="true"></b-icon>
                    Menu</a>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/rastrear-pedido"
                  ><a class="nav-link text-white"
                    ><b-icon icon="geo-alt-fill" aria-hidden="true"></b-icon>
                    Rastrea tu pedido</a
                  ></router-link
                >
              </li>
              <li class="nav-item dropdown" v-show="logueado">
                <a  class="nav-link dropdown-toggle text-white" href="#" id="navbarDropdown" data-toggle="dropdown" aria-expanded="false" @click="ocultarOpciones">
                  <b-icon icon="person-fill"></b-icon>
                  {{ this.$store.state.user_name }}
                </a>
                <div id="dropdown" class="dropdown-menu dropdown-menu-right  text-dark" aria-labelledby="navbarDropdown">
                  <router-link to="/cambiar-contrasena">
                    <a class="nav-link text-dark"><b-icon icon="lock-fill" aria-hidden="true"></b-icon>Cambiar contraseña</a>
                  </router-link>
                  <a class="nav-link" @click="logout" href="#">
                    <b-icon icon="box-arrow-in-right" aria-hidden="true"></b-icon> Cerrar sesión
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <main class="main container-fluid">
              <slot />
              <div v-if="isMenu && logueado" class="container mt-4">
                <h3 class="text-center mb-3">Mis paquetes (Último mes)</h3>
                <HistorialTable
                    :paquetes="paquetes"
                    :cargando="cargando"
                    @rastrear="onRastrear"
                />
              </div>

              <div v-if="logueado && !isMenu && !isLoginPage" class="d-flex justify-content-center">
                <b-button @click="goBack" pill class="d-flex align-items-center">
                  <b-icon-house-door class="mr-2"/>Regresar</b-button>
              </div>

              <b-modal title="Rastrear" size="lg" ok-only ok-variant="dark" v-model="modalShow">
                <div class="panel panel-default ng-scope">
                  <div class="panel-heading font-bold ng-binding">
                    <span>Trackings : {{track}}</span>
                    <br /> Hawb : {{hawb}}
                    <br />
                  </div>
                  <table class="table table-striped b-t ng-hide" v-if="guias_agrupadas.length > 0">
                    <thead>
                    <tr>
                      <th colspan="3">Guías agrupadas</th>
                    </tr>
                    <tr>
                      <th>Fecha de creación</th>
                      <th>HAWB</th>
                      <th>Tracking</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="guia in guias_agrupadas" v-bind:key="guia.id">
                      <td>{{guia.created_at}}</td>
                      <td>{{guia.hawb}}</td>
                      <td>{{guia.tracking_tienda_casillero}}</td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="table-responsive app-table">
                    <table class="table table-striped b-t">
                      <thead>
                      <tr>
                        <th class="text-center" colspan="3">Trackings</th>
                      </tr>
                      <tr>
                        <th>Fecha de creación</th>
                        <th>Estado</th>
                        <th>Observación</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="tracking in trackings" v-bind:key="tracking.id">
                        <td>{{tracking.created_at}}</td>
                        <td>{{tracking.estado_de_guia.descripcion_alterna}}</td>
                        <td>{{tracking.observacion}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </b-modal>
            </main>
          </div>
          <!-- /#page-content-wrapper -->
        </div>
        <!-- /#wrapper -->
      </body>
    </template>

    <script>
    import { logear } from "../plugins/conn";
    import { api } from "@/plugins/api_conect";
    import HistorialTable from "@/components/HistorialTable.vue";

    export default {
      components: {
        HistorialTable
      },
      data() {
        return {
          submitted: false,
          password: "",
          // Historial Data
          paquetes: [],
          cargando: false,
          modalShow: false,
          track: "",
          hawb: "",
          trackings: [],
          guias_agrupadas: [],
        };
      },
      computed: {
        logueado() {
          return this.$store.getters.loggedIn;
        },
        isMenu() {
          return this.$route.name === 'Menu';
        },
        isLoginPage() {
          return this.$route.name === 'Login';
        }
      },
      watch: {
        $route(to) {
          if (to.name === 'Menu' && this.logueado) {
            this.fetchLastMonthPackages();
          }
        }
      },
      mounted() {
        if (this.isMenu && this.logueado) {
          this.fetchLastMonthPackages();
        }
      },
      methods: {
        fetchLastMonthPackages() {
          this.cargando = true;
          const endDate = new Date();
          const startDate = new Date();
          startDate.setMonth(startDate.getMonth() - 1);

          const payload = {
            fecha_inicial: startDate.toISOString().substr(0, 10),
            fecha_final: endDate.toISOString().substr(0, 10),
            str_busqueda: "",
            orden_de_compra: "",
            cliente_id: localStorage.getItem('cliente_id'),
            tipo_proceso: "TODOS",
            pageNumber: 1,
            pageSize: 10 // Limit for dashboard view
          };

          api().post(`/api/casillero/clientes/historial/busqueda?page=1`, payload, {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: localStorage.getItem('token_type') + " " + localStorage.getItem('access_token')
            },
          })
          .then((response) => {
            const { data } = response;
            this.paquetes = data["datos"]["data"];
          })
          .catch(() => {
            // Silent fail or simplified error for dashboard to not interrupt navigation
            console.error("Error fetching historial packages");
          })
          .finally(() => {
            this.cargando = false;
          });
        },
        onRastrear(paquete) {
          this.modalShow = true;
          this.track = paquete.tracking_tienda_casillero;
          this.hawb = paquete.hawb;
          this.trackings = [];
          this.guias_agrupadas = [];

          api().get(`/api/casillero/historial/rastrear/${paquete.id}`, {
            method: "get",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: localStorage.getItem('token_type') + " " + localStorage.getItem('access_token')
            }
          })
          .then((response) => {
            const { data } = response
            this.guias_agrupadas = data["datos"]["guias_agrupadas"];
            this.trackings = data["datos"]["trackings"];
          }).catch(async (error) => {
            if (error.response && error.response.status === 401) {
              await this.$auth.refreshToken();
              this.onRastrear(paquete);
            }
          });
        },
        ocultarHeader() {
      document
        .getElementById("navbarSupportedContent")
        .classList.toggle("show");
    },
    ocultarOpciones() {
      document.getElementById("dropdown").classList.toggle("show");
    },
    logout() {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("token_type");
      localStorage.removeItem("user_id");
      localStorage.removeItem("user_name");
      localStorage.removeItem("cliente_id");
      localStorage.removeItem("datosUsuario");
      localStorage.removeItem("datosCliente");
      localStorage.removeItem("tokensExpiry");
      this.$cookies.remove("clienteId");
      window.location.href = `${process.env.VUE_APP_URL}/`;
    },
    showModal() {
      this.submitted = true;
      this.password = "";
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.submitted = false;
      this.$refs["my-modal"].hide();
    },
    loggedIn() {
      this.submitted = true;
      logear(this.password, this.$store, this.$cookies, this.$swal, this.$refs["my-modal"]);
    },
    goBack() {
      window.location.href = `${process.env.VUE_APP_URL}/`
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main{
  min-height: 100%;
}
.h-full{
  max-height: unset;
  height: 100%;
  min-height: 100vh;
}
a{
  text-decoration: none !important;
}
.letra {
  color: #000 !important;
}

.dropdown-item:active ,.dropdown-item:hover{
  background-color: #A6BF4F;
  color: #fff !important;
  transition: color 0.3s ease;
}
.navbar-toggler {
  background-color: #fff !important;
}
a#imagen {
  position: relative;
  scale: 1.2;
}
a img{
  position: relative;
  z-index: 1;
}

a#imagen:before {
    content: "";
    position: absolute;
    top: -22px;
    left: -40px;
    width: 150%;
    height: calc(100% + 1.5rem);
    background: #fff;
    transform: skew(-20deg);
    z-index: 2;
}

#sidebar-wrapper {
  min-height: 100vh;
  margin-left: -15rem;
  -webkit-transition: margin 0.25s ease-out;
  -moz-transition: margin 0.25s ease-out;
  -o-transition: margin 0.25s ease-out;
  transition: margin 0.25s ease-out;
}

#sidebar-wrapper .sidebar-heading {
  padding: 0.875rem 1.25rem;
  font-size: 1.2rem;
}

#sidebar-wrapper .list-group {
  width: 15rem;
}

#page-content-wrapper {
  min-width: 100vw;
}

.custom-logo {
  height: 60px;
  width: auto;
}
#wrapper.toggled #sidebar-wrapper {
  margin-left: 0;
}
#dropdown .nav-link:hover{
  background-color: var(--secondary-color);
  color: #fff !important;
}
@media (min-width: 768px) {
  #sidebar-wrapper {
    margin-left: 0;
  }
  #page-content-wrapper {
    min-width: 0;
    width: 100%;
  }
  #wrapper.toggled #sidebar-wrapper {
    margin-left: -15rem;
  }
}
</style>
